module.exports = __webpack_public_path__ + "static/media/logo-small-white.b5f2a306.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/branding/logo-small-white.png
// module id = 827
// module chunks = 0